import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// context
import { useUserState } from '../../helpers/UserContext';

export default function TeacherRoute({ component, ...rest }) {
  // global
  var { isAuthenticated, user } = useUserState();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated && user.role === 1 ? (
          React.createElement(component, props)
        ) : user.role === 2 ? (
          <Redirect
            to={{
              pathname: '/app/dashboard',
              state: {
                from: props.location,
              },
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                from: props.location,
              },
            }}
          />
        )
      }
    />
  );
}
